import { computed, inject, Injectable, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthFacade, Principal } from './auth.facade';
import { AuthService } from '../services/auth/auth.service';
import { GuestUserService } from '../services/user/guest-user.service';
import { Credentials } from '../models/Credentials';
import { User } from '../models/User';
import { GuestUser } from '../models/GuestUser';

@Injectable()
export class AuthFacadeImpl extends AuthFacade {
  private readonly authService = inject(AuthService);
  private readonly guestUserService = inject(GuestUserService);

  readonly principal: Signal<Principal> = computed<Principal>(() => {
    const user: User | null = this.authService.currentUser();
    if (user) {
      return { kind: 'user', user };
    }
    const guestUser: GuestUser | null = this.guestUserService.currentGuestUser();
    if (guestUser) {
      return { kind: 'guest', guestUser };
    }
    return { kind: 'anonymous' };
  });

  readonly isAuthenticated: Signal<boolean> = computed(() => this.principal().kind === 'user');

  readonly isGuest: Signal<boolean> = computed(() => this.principal().kind === 'guest');

  login(credentials: Credentials): Observable<void> {
    return this.authService.login(credentials);
  }

  logout(): void {
    void this.authService.logout();
  }
}
